import axios, { InternalAxiosRequestConfig } from "axios";
import { getAccessToken } from "../utils/authUtils";
import { triggerToast } from "../components/common/GlobalToast";

/* =====================================================
    Axios Instance
   ===================================================== */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* =====================================================
    MSAL Instance Holder
   ===================================================== */
let msalInstance: any = null;
let toastShown = false;

export const setMsalInstance = (instance: any) => {
  msalInstance = instance;
};

/* =====================================================
    APIs that do NOT need Role / Region / Plant
   (keep empty or add paths like /login, /health if needed)
   ===================================================== */
const SKIP_CONTEXT_APIS: string[] = ["/api/user-details/get-info",
  "/api/admin/getadmin",
  "/api/admin/get-plants",
  "/api/admin/get-plants","/api/admin/getApprovers","/api/admin/error-view","/api/support/ticket/fetch-tickets","/api/admin/get-writeback-dates"];

/* =====================================================
    REQUEST INTERCEPTOR
   ===================================================== */
axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    /*  Skip context logic for excluded APIs */
     const token = await getAccessToken(msalInstance);
    if (
      config.url &&
      SKIP_CONTEXT_APIS.some((api) => config.url!.includes(api))
    ) {
          
    if (!token) {
      throw new Error("Failed to acquire access token");
    }

    (config.headers as any).Authorization = `Bearer ${token}`;
      return config;
    }

    /*  Ensure MSAL exists */
    if (!msalInstance) {
      throw new Error("MSAL instance not initialized");
    }

    /*  Attach access token */
   
    if (!token) {
      throw new Error("Failed to acquire access token");
    }

    (config.headers as any).Authorization = `Bearer ${token}`;

    /*  Read values from sessionStorage */
    const role = sessionStorage.getItem("selectedRole");
    const region = sessionStorage.getItem("selectedRegion");
    const plantRaw = sessionStorage.getItem("selectedPlant");

    let plantArray: string[] = [];
    try {
      plantArray = plantRaw ? JSON.parse(plantRaw) : [];
    } catch {
      plantArray = [];
    }

    /*  Convert plant array to comma‑separated string */
    const plant = plantArray.join(",");

    /*  Validation: Role + Region + Plant */
    if (!role || !region || !plant) {
      // if (!toastShown) {
      //   triggerToast("Please select Role, Region and Plant before proceeding.", "warning");
      //   toastShown = true;
      // }

      /* ❌ Block API call */
      return Promise.reject({
        message: "Missing role, region or plant",
        isContextError: true,
      });
    }

    toastShown = false;

    const method = (config.method || "get").toLowerCase();

    /* =====================================================
        GET → Attach as query params
       ===================================================== */
    if (method === "get") {
      config.params = {
        ...(config.params || {}),
         role,
         region,
         plant,
      };
    }

    /* =====================================================
        POST / PUT / PATCH / DELETE → Attach to body
       ===================================================== */
    // else {
    //   if (config.data instanceof FormData) {
    //     config.data.append("role", role);
    //     config.data.append("region", region);
    //     config.data.append("plant", JSON.parse(plantRaw) || []);
    //   } else {
    //     config.data = {
    //       ...(config.data || {}),
    //       role,
    //       region,
    //       plant: JSON.parse(plantRaw) || [],
    //     };
    //   }
    // }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =====================================================
    RESPONSE INTERCEPTOR (UNCHANGED)
   ===================================================== */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK" || error?.response?.status === 503) {
      window.location.href = "/maintenance";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;